module.exports = __webpack_public_path__ + "static/media/yesterdayImage2ForArchive.9490d717.png";